// zendesk.service.ts
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

declare global {
  interface Window {
    zE?: any;
  }
}

@Injectable({
  providedIn: 'root'
})
export class ZendeskService {
  private widgetLoaded = false;

  constructor(private httpClient:HttpClient){}

  loadWidget(): void {
    if (this.widgetLoaded) return;
    const script = document.createElement('script');
    script.id = 'ze-snippet';
    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${environment.zendeskKey}`;
    script.async = true;
    script.onload = () => {
      this.widgetLoaded = true;
    };
    document.body.appendChild(script);
  }

  openChat() {
    window.zE?.('messenger', 'open');
  }

  closeChat() {
    window.zE?.('messenger', 'close');
  }

  setUserIdentity(userId:string , name:string, email:string) {
  if (window.zE) {
    const eName = encodeURIComponent(name);
    const url = `${environment.apiURL}api/zendesk/jwt?userId=${userId}&name=${eName}&email=${email}`;
   window.zE("messenger", "loginUser",
  function jwtCallback(callback) {
    fetch(url)
      .then(response => response.json())
      .then(data => {
        callback(data.token); 
      })
      .catch(error => {
        console.error('JWT fetch failed:', error);
      });
  },
  function loginCallback(status) {
    if (status === 'success') {
      console.log('User successfully logged in to Zendesk.');
    } else {
      console.error('Zendesk login failed:', status);
    }
  },userId=userId
);

  } else {
    console.warn('Zendesk SDK not loaded yet.');
  }
}

logoutUser(){
  window.zE?.('messenger', 'logoutUser');
}
}
